/*
 * Copyright (c) 2024 GM Global Technology Operations LLC. All rights reserved.
 * This information is confidential and proprietary to GM Global Technology
 * Operations LLC and may not be used, modified, copied or distributed.
 */

import React, {PropsWithChildren} from 'react'
import styled from "styled-components";
import ArgosDialogHeader from "./ArgosDialogHeader";

import {Dialog, IconButton, Typography} from '@mui/material';
import CloseIcon from '@mui/icons-material/Close';
import ArgosFlexbox from '../Containers/ArgosFlexbox';

interface ArgosDialogProps {
  width?: string
  minWidth?: string
  maxWidth?: string
  height?: string
  maxHeight?: string
  headerTitle?: React.ReactNode,
  headerTitleAlign?: 'center' | 'left' | 'right'
}

const defaultWidth = '90vw'
const defaultHeight = '90vh'

export const StyledArgosDialog = styled(Dialog)<any>((props) => ({
  "& .MuiDialog-container": {
    "& .MuiPaper-root": {
      minWidth: props?.minWidth ?? props?.width ?? defaultWidth,
      maxWidth: props?.maxWidth ?? props?.width ?? defaultWidth,
      height: props?.height ?? defaultHeight,
      maxHeight: props?.maxHeight ?? defaultHeight,
    },
  },
}))

interface WrapperProps {
  open: boolean
  onClose?: () => void,
}

export type IArgosDialogProps = PropsWithChildren<WrapperProps & ArgosDialogProps>
const ArgosDialog = (props: IArgosDialogProps) => {

  return (
    <StyledArgosDialog {...props} open={props.open} onClose={props.onClose}>
      <div style={{display: 'flex', flexDirection: 'column', height: '100%'}}>
        <div style={{display: props?.headerTitle ? 'initial' : 'none'}}>
          <ArgosDialogHeader>
            <ArgosFlexbox style={{justifyContent: 'space-between', alignItems: 'center'}}>
              <Typography sx={{color: 'white', fontSize: 14, textAlign: props?.headerTitleAlign ?? 'initial'}}>
                {props?.headerTitle ?? ''}
              </Typography>
              {props.onClose && (
                <IconButton onClick={props.onClose} sx={{color: 'white', padding: 0, fontSize: 'small'}}>
                  <CloseIcon/>
                </IconButton>
              )}
            </ArgosFlexbox>
          </ArgosDialogHeader>
        </div>
        <div style={{flex: 1, overflow: 'auto', padding: 10}}>
          {props.children}
        </div>
      </div>
    </StyledArgosDialog>
  )
}


export default ArgosDialog